import * as React from "react";
const DictionaryContext = /*#__PURE__*/React.createContext({});
DictionaryContext.displayName = "DictionaryOrbitContext";
export default DictionaryContext;